export default __webpack_public_path__ + "static/media/file-icon-g.a06f9369.svg";